import { Home, AlertCircle, AlertTriangle } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router-dom';
import { Button, IconButton, Modal } from './ui';

type AlertColor = 'success' | 'error' | 'warning' | 'info';

const severityClasses: Record<AlertColor, string> = {
  success: 'bg-emerald-50 border-emerald-500 text-emerald-800',
  error: 'bg-red-50 border-red-500 text-red-800',
  warning: 'bg-amber-50 border-amber-500 text-amber-800',
  info: 'bg-blue-50 border-blue-500 text-blue-800',
};

export default function Message(props: { titre?: string, messageAlert: string, messageDialog?: string, type: AlertColor }) {

  const [open, setOpen] = React.useState(false);
  const [openBtn, setOpenBtn] = React.useState(true);

  const handleClickOpenNotif = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseSnack = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const ressource = ['Bien brancher un cable réseaux', 'Procédure de retrait', 'Effectuer un virement', 'Bien brancher un cable réseaux', 'Procédure de retrait', 'Effectuer un virement'];

  return (
    <div>
      {/* Notification façon snackbar (toujours visible) */}
      <div
        className={`message fixed bottom-6 left-6 z-[2000] flex items-center gap-3 px-4 py-3 rounded-xl border-l-4 shadow-lg cursor-pointer ${severityClasses[props.type]}`}
        onClick={handleClickOpenNotif}
        draggable
      >
        <span className="flex-1 text-sm font-medium">{props.messageAlert}</span>
        {props.type == "success" && (
          <Link to={'/'} style={{ textDecoration: 'none' }}>
            <IconButton
              aria-label="close"
              color="success"
              size={28}
              onClick={() => {
                setOpen(false);
              }}
            >
              <Home size={16} />
            </IconButton>
          </Link>
        )}
      </div>

      <Modal
        open={props.type != "success" ? open : false}
        onClose={handleClose}
        title={
          <span className="notif flex items-center gap-2">
            {props.titre}
            {props.type == "error"
              ? <AlertCircle size={18} className="text-red-600" />
              : <AlertTriangle size={18} className="text-amber-500" />}
          </span>
        }
        footer={
          <>
            <Link style={{ textDecoration: 'none' }} to={'/'}>
              <Button variant='ghost' className="!text-emerald-600" autoFocus onClick={handleClose}>Home</Button>
            </Link>
            <Button
              variant='outline'
              className={props.type == "error"
                ? '!text-red-600 !border-red-400 hover:!bg-red-50'
                : '!text-amber-600 !border-amber-400 hover:!bg-amber-50'}
              onClick={handleClose}
              autoFocus
            >
              Ok
            </Button>
          </>
        }
      >
        <p className="notif text-sm text-[var(--eb-text)]">{props.messageDialog}</p>
      </Modal>
    </div>
  );
}
function handleListItemClick(ressource: string) {
  alert(ressource)

}
